import { CFC } from "@api/types/cypress";

const Label: CFC<{ text: string; required: boolean }> = ({ text = "", required = false }) => (
  <div className="label">
    <span className={required ? "required" : ""}>{text + ":"}</span>
    <style jsx>
      {`
        .label {
          margin: 10px 0 0 0;
        }

        .required::before {
          content: "*";
          color: red;
        }
      `}
    </style>
  </div>
);

export default Label;
